import { useParams } from 'react-router-dom';

import { useLoadConsumerStatsQuery } from '@hook/stats/stats.hooks';
import { isString } from '@util/data/is-exist';

export const useConsumerStats = () => {
  const { consumerId = '' } = useParams();

  return useLoadConsumerStatsQuery(consumerId, {
    skip: !isString(consumerId),
    refetchOnMountOrArgChange: true,
  });
};
